import React from 'react';
import styles from './OptimizedLoadingSpinner.module.css';

const OptimizedLoadingSpinner: React.FC = () => (
  <div className={styles.loadingContainer}>
    <div className={styles.spinner}></div>
    <p className={styles.loadingText}>Loading...</p>
  </div>
);

export default OptimizedLoadingSpinner;
